import React, { useState } from 'react';
import Portal from '../common/Portal';
import DatePicker from 'react-datepicker';

const AddFeedItemModal = ({ isOpen, onClose, onSubmit }) => {
    const getInitialState = () => ({
        name: '',
        quantity: '',
        totalCost: '',
        purchaseDate: new Date(),
        protein: '',
        fat: '',
        lowStockThreshold: ''
    });
    const [item, setItem] = useState(getInitialState());
    
    const handleChange = e => setItem(prev => ({ ...prev, [e.target.name]: e.target.value }));
    const handleDateChange = date => setItem(prev => ({ ...prev, purchaseDate: date }));
    
    const handleSubmit = e => { 
        e.preventDefault(); 
        onSubmit(item); 
        onClose(); 
    };

    if (!isOpen) return null;

    return (
        <Portal>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-lg m-4">
                    <h2 className="text-2xl font-bold mb-6">Add New Feed Item</h2>
                    <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Feed Name</label>
                            <input name="name" onChange={handleChange} required className="mt-1 w-full form-input rounded-md shadow-sm"/>
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Purchase Date</label>
                            <DatePicker
                                selected={item.purchaseDate}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM-dd"
                                className="mt-1 block w-full form-input rounded-md shadow-sm"
                                wrapperClassName="w-full"
                                maxDate={new Date()}
                                portalId="portal-root"
                                popperClassName="high-z-datepicker"
                                required
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Quantity Purchased (kg)</label>
                            <input name="quantity" type="number" step="any" onChange={handleChange} required className="mt-1 w-full form-input rounded-md shadow-sm"/>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Total Cost (₹)</label>
                            <input name="totalCost" type="number" step="0.01" onChange={handleChange} required className="mt-1 w-full form-input rounded-md shadow-sm"/>
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700">Low Stock Threshold (kg)</label>
                            <input name="lowStockThreshold" type="number" step="any" onChange={handleChange} required className="mt-1 w-full form-input rounded-md shadow-sm"/>
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Protein % (Optional)</label>
                            <input name="protein" type="number" step="0.1" onChange={handleChange} className="mt-1 w-full form-input rounded-md shadow-sm"/>
                        </div>
                        
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Fat % (Optional)</label>
                            <input name="fat" type="number" step="0.1" onChange={handleChange} className="mt-1 w-full form-input rounded-md shadow-sm"/>
                        </div>

                        <div className="col-span-full mt-4 flex justify-end space-x-3">
                            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
                            <button type="submit" className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700">Add Item</button>
                        </div>
                    </form>
                </div>
            </div>
        </Portal>
    );
};

export default AddFeedItemModal;